// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HamburgerMenu_wrapper__3570g","HamburgerMenu":"HamburgerMenu_HamburgerMenu__DljVe","hbBtn":"HamburgerMenu_hbBtn__2ppb3","dropdown":"HamburgerMenu_dropdown__3D3-z"};